module.exports = __webpack_public_path__ + "static/media/company-address-sample-1.9c77f8fd.png";